import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import type { OSCE } from '@ils/osces/db/osce.js';
import { Names } from '@ils/static/names.js';
import type { UpdateResult } from 'mongodb';
import { finalRatingDocAfterUpdate } from '../server/resolver/finalRating.js';
import { ExamSlotRatingDoc } from './rating.js';
import { ExamSlotFinalRating } from './slotFinalRating.js';

@Entity()
export class ExamSlotFinalRatingDoc extends ExamSlotRatingDoc {
  public static override _class = Names.ExamSlotFinalRatingDoc._class;

  constructor(doc: PartialEntityData<ExamSlotFinalRatingDoc>) {
    super(doc);
  }

  @Field(type => [ExamSlotFinalRating])
  override ratings!: ExamSlotFinalRating[];

  @Field(type => Boolean, { default: v => v ?? false })
  linguistCommitted!: boolean;

  @Field(type => Boolean, { default: v => v ?? false })
  doctorCommitted!: boolean;

  static override async afterUpdate(
    oldEntity: PartialEntityData<MongoEntity>,
    newEntity: MongoEntity,
    result: UpdateResult,
  ) {
    super.afterUpdate(oldEntity, newEntity, result);
    await finalRatingDocAfterUpdate(oldEntity, newEntity, result);
  }

  public static override fromOSCE(osce: OSCE, inspector: string) {
    return new ExamSlotFinalRatingDoc({
      inspector,
      committed: false,
      ratings: (osce.instructionCategories ?? [])
        .flatMap(cat => cat.instructions)
        .map(instruction => new ExamSlotFinalRating({ instructionId: instruction._id, score: -1 })),
    });
  }
}
